function getItemRatings({ metadataIds }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/ratings`;
  return apiClient.get(route, { query: { metadataIds } });
}

function rateItem({ metadataId, rating }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/ratings/${metadataId}`;
  return apiClient.post(route, { metadataId, rating });
}

function changeItemRating({ metadataId, rating }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/ratings/${metadataId}`;
  return apiClient.patch(route, { metadataId, rating });
}

function removeItemRating({ metadataId }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/ratings/${metadataId}`;
  return apiClient.delete(route);
}

export default {
  getItemRatings,
  rateItem,
  changeItemRating,
  removeItemRating
};



// WEBPACK FOOTER //
// ./app/api/RatingsApi.js